import {
  Box,
  Flex,
  FlexProps,
  FormControl,
  FormLabelProps,
  Text,
  Textarea,
  TextareaProps,
} from '@chakra-ui/react';
import { useField } from 'formik';

import Label from './Label';

interface Props extends FlexProps {
  name: string;
  placeholder?: string;
  max?: number;
  size?: 'sm' | 'md' | 'lg';
  fontSize?: string;
  label?: string;
  labelProps?: FormLabelProps;
  showMaxLimit?: boolean;
  variant?: TextareaProps['variant'];
  _input?: TextareaProps;
}

const TextBox = ({
  name,
  placeholder,
  max = 300,
  size = 'lg',
  fontSize = '16px',
  label,
  labelProps,
  showMaxLimit = false,
  _input,
  variant,
  ...props
}: Props) => {
  const [field, meta] = useField<string>(name);
  const { value, onBlur, onChange } = field;
  const isInvalid = meta.touched && meta.error != null;
  const currentLength = value?.length || 0;

  return (
    <Flex flexDir="column" {...props}>
      <FormControl isInvalid={isInvalid} position="relative">
        {label && (
          <Label variant={variant} {...labelProps}>
            {label}
          </Label>
        )}
        <Textarea
          size={size}
          resize="vertical"
          rows={4}
          name={name}
          value={value}
          placeholder={placeholder}
          maxLength={max}
          fontSize={fontSize}
          onBlur={onBlur}
          onChange={onChange}
          isInvalid={isInvalid}
          variant={variant}
          {..._input}
        />

        <Flex justifyContent="space-between" wrap="wrap">
          {isInvalid && (
            <Box color="leaseEndRed" fontSize="12.25px" ml="5px" mt="8px">
              {meta.error}
            </Box>
          )}
          {showMaxLimit && (
            <Text fontSize="12px" color="gray.500" ml="auto">
              {currentLength}/{max}
            </Text>
          )}
        </Flex>
      </FormControl>
    </Flex>
  );
};

export default TextBox;
